import { parseCertificate } from '@/services/certs.service'
const asn1js = require('asn1js')
const pkijs = require('pkijs')

export const state = {
}

export const getters = {
  getParsedCertificate: () => (pkiCert) => {
    return parseCertificate({ cert: pkiCert })
  }
}

export const mutations = {
}

export const actions = {
  doParseCertificate ({ rootState, getters }, { certName }) {
    const hsm = rootState.hsm.instance
    return hsm.exportObject({ obj: certName })
      .then(material => {
        const buffer = new Uint8Array(material).buffer
        const asn1 = asn1js.fromBER(buffer)
        const Certificate = pkijs.Certificate
        const pkiCert = new Certificate({ schema: asn1.result })
        return getters.getParsedCertificate(pkiCert)
      })
  }
}
